import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "aria-modal": "true",
  ref: "confirmation-dialog-content-ref",
  class: "modal-buttons"
}

import { ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
    modal: { type: Boolean },
    closable: { type: Boolean },
    dismissableMask: { type: Boolean },
    header: {},
    buttonTextCancel: {},
    buttonTextConfirm: {},
    isRedButton: { type: Boolean },
    smallerTitle: { type: Boolean },
    isVibrantPurple: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {


let visible = ref(false);
const props = __props;

/* eslint-disable-next-line no-unused-vars */
let resolvePromise: ((_value: boolean) => void) | null = null;

const show = (): Promise<boolean> => {
  visible.value = true;

  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
};

const confirm = () => {
  visible.value = false;
  if (resolvePromise) {
    resolvePromise(true);
  }
};

const cancel = () => {
  visible.value = false;
  if (resolvePromise) {
    resolvePromise(false);
  }
};

const handleCancel = (event: KeyboardEvent) => {
  if (event.key === "Enter") {
    event.preventDefault();
    (event.target as HTMLElement).blur();
    cancel();
  }
}

const handleConfirm = (event: KeyboardEvent) => {
  if (event.key === "Enter") {
    event.preventDefault();
    (event.target as HTMLElement).blur();
    confirm();
  }
}

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_focustrap = _resolveDirective("focustrap")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _unref(visible),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
    modal: props.modal,
    closable: props.closable,
    header: props.header,
    dismissableMask: props.dismissableMask,
    class: _normalizeClass(['dialog-wrapper', _ctx.smallerTitle && 'smaller-title']),
    "aria-labelledby": `Confirmation to ${props.header}`,
    "aria-expanded": _unref(visible),
    "close-on-escape": true
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Button, {
          onClick: cancel,
          onKeydown: handleCancel,
          class: "modal-button light-grey",
          label: props.buttonTextCancel,
          "aria-label": props.buttonTextCancel,
          autofocus: ""
        }, null, 8, ["label", "aria-label"]),
        _createVNode(_component_Button, {
          onClick: confirm,
          onKeydown: handleConfirm,
          class: _normalizeClass({
          'modal-button': true,
          'red': _ctx.isRedButton,
          'light-purple': !_ctx.isRedButton && !_ctx.isVibrantPurple,
          'vibrant-purple': _ctx.isVibrantPurple
        }),
          label: props.buttonTextConfirm,
          "aria-label": props.buttonTextConfirm
        }, null, 8, ["class", "label", "aria-label"])
      ])), [
        [_directive_focustrap]
      ])
    ]),
    _: 3
  }, 8, ["visible", "modal", "closable", "header", "dismissableMask", "class", "aria-labelledby", "aria-expanded"]))
}
}

})